import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type StaffState = Readonly<{
  selectedStaff: number;
  editMode: boolean;
}>;

export const initialState: StaffState = {
  selectedStaff: 0,
  editMode: false,
};

export const staffSlice = createSlice({
  name: "staff",
  initialState,
  reducers: {
    setEditMode: (state, action: PayloadAction<boolean>) => {
      state.editMode = action.payload;
    },
    setSelectedStaff: (state, action: PayloadAction<number>) => {
      state.selectedStaff = action.payload;
    },
  },
});

export const { setEditMode, setSelectedStaff } = staffSlice.actions;

export const staffReducer = staffSlice.reducer;
